export default function parseErrorData(data) {
  let parsed;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch (e) {
    parsed = null;
  }
  return parsed;
}